import { ReactNode } from 'react'
import cx from 'classnames'
import styles from './Tag.module.css'

/** 시안 `.tag` + `.g/.w/.c/.n/.k` 이식. tone 이름이 곧 클래스명이다. */
export type TagProps = {
  tone: 'good' | 'warn' | 'crit' | 'neutral' | 'strong'
  children: ReactNode
}

export const Tag = ({ tone, children }: TagProps): JSX.Element => (
  <span className={cx(styles.tag, styles[tone])}>{children}</span>
)
